import Banner from '@zenbusiness/zui/Banner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

import { ACCOUNT_STATUS } from '#client/constants/account';
import useUnitAccount from '#client/hooks/useUnitAccount';
import { BannerWrapperStyled } from '#client/pages/SharedStyles';

import { LinkStyled } from './styles';

const CONTACT_US_URL = 'https://www.zenbusiness.com/d/help';
const MONEY_SUPPORT = 'mailto:moneysupport@zenbusiness.com';

export default function FrozenAccountBanner() {
  const { loading: loadingUnitAccount, unitAccount } = useUnitAccount();
  const isAccountFrozen = unitAccount?.status === ACCOUNT_STATUS.FROZEN;

  if (loadingUnitAccount) {
    return undefined;
  }

  return isAccountFrozen ? (
    <BannerWrapperStyled>
      <Banner
        slotProps={{
          primaryAction: {
            label: 'Contact us',
            to: CONTACT_US_URL
          }
        }}
        slots={{
          startIcon: (
            <SharedAsset
              alt=""
              color="#E53535"
              src="/s2/icon/warning-sign-fill.svg"
              width={34}
            />
          )
        }}
        subtitle={
          <Text size="sm">
            To learn more, reach out to 1 (844) 4-ZENBIZ or email{' '}
            <LinkStyled href={MONEY_SUPPORT}>moneysupport@zenbusiness.com</LinkStyled>.
          </Text>
        }
        title="Your account has been temporarily frozen"
        variant="alert"
      />
    </BannerWrapperStyled>
  ) : null;
}
